import { useQuery, UseQueryOptions } from 'react-query';
import { AdGroupDto } from '../../../codegen/Swagger';
import { getApi } from '../../../config/SwaggerApi';
import { configQueryReactSimpleRequestSecurity } from '../config';
const fetchGroups = () =>
    getApi()
        .security.securityGetAdGroupsGet()
        .then((response) => response.data);

const useSecurityGroups = (options?: UseQueryOptions) => {
    const groupsQuery = useQuery<AdGroupDto[], Error>('security-groups', fetchGroups, {
        ...configQueryReactSimpleRequestSecurity,
    });

    return groupsQuery;
};

export default useSecurityGroups;
